export function extractTemasSummary(propertyData) {
  const props = propertyData?.properties;
  const lista = Array.isArray(props?.sobreposicao)
    ? props.sobreposicao
    : Array.isArray(props?.temas)
      ? props.temas
      : null;
  if (!props || !Array.isArray(lista)) {
    return {
      biomaPredominante: null,
      flags: {
        uc: false,
        aldeias: false,
        florestas: false,
        mineracao: false,
        pra: false,
        quilombolas: false,
        assentamentos: false,
        embargos_ibama: false,
        terras_indigenas: false,
        curso_dagua: false,
        curso_dagua_trecho: false,
        massa_dagua: false,
        rios: false,
      },
      counts: {
        uc: 0,
        aldeias: 0,
        florestas: 0,
        mineracao: 0,
        pra: 0,
        quilombolas: 0,
        assentamentos: 0,
        embargos_ibama: 0,
        terras_indigenas: 0,
        curso_dagua: 0,
        curso_dagua_trecho: 0,
        massa_dagua: 0,
        rios: 0,
      },
    };
  }

  const agg = {
    biomas: new Map(),
    flags: {
      uc: false,
      aldeias: false,
      florestas: false,
      mineracao: false,
      pra: false,
      quilombolas: false,
      assentamentos: false,
      embargos_ibama: false,
      terras_indigenas: false,
      curso_dagua: false,
      curso_dagua_trecho: false,
      massa_dagua: false,
      rios: false,
    },
    counts: {
      uc: 0,
      aldeias: 0,
      florestas: 0,
      mineracao: 0,
      pra: 0,
      quilombolas: 0,
      assentamentos: 0,
      embargos_ibama: 0,
      terras_indigenas: 0,
      curso_dagua: 0,
      curso_dagua_trecho: 0,
      massa_dagua: 0,
      rios: 0,
    },
  };

  for (const item of lista) {
    const temas = item?.temas || {};

    // Biomas: somar pct_imovel por nome do bioma
    const biomas = Array.isArray(temas.biomas) ? temas.biomas : [];
    for (const b of biomas) {
      const nome = (b?.bioma || '').trim();
      const pct = Number(b?.pct_imovel) || 0;
      if (!nome) continue;
      agg.biomas.set(nome, (agg.biomas.get(nome) || 0) + pct);
    }

    // Flags: verdadeiro se existir qualquer item no array
    const keys = [
      'uc',
      'aldeias',
      'florestas',
      'mineracao',
      'pra',
      'quilombolas',
      'assentamentos',
      'embargos_ibama',
      'terras_indigenas',
      'curso_dagua',
      'curso_dagua_trecho',
      'massa_dagua',
      'rios',
    ];
    for (const k of keys) {
      const arr = temas?.[k];
      const len = Array.isArray(arr) ? arr.length : 0;
      if (!agg.flags[k] && len > 0) agg.flags[k] = true;
      agg.counts[k] += len;
    }
  }

  // Bioma predominante = maior soma de pct
  let biomaPredominante = null;
  let maxPct = -1;
  for (const [nome, pct] of agg.biomas.entries()) {
    if (pct > maxPct) {
      maxPct = pct;
      biomaPredominante = nome;
    }
  }

  return {
    biomaPredominante,
    flags: agg.flags,
    counts: agg.counts,
  };
}
